import clsx from 'clsx'
import Image from 'next/image'

import Link from '@/atoms/Link/Link'

/* assets */
import { ReactComponent as LinkedIn } from 'public/assets/icons/events/linkedIn-blue.svg'

/* styles */
import styles from './_.module.css'

interface Props {
  aboutSession: string
  takeaways: string
  speakersList: StrapiSpeakerDetailsCardComponent[]
}

function EventDetails({ aboutSession, takeaways, speakersList }: Props) {
  return (
    <section className="font-body text-black">
      <div className="container | grid grid-cols-1 md:grid-cols-12 gap-8 | py-12 md:pt-12">
        <div className="md:col-span-5">
          <h2 className="font-heading text-2xl md:text-3xl text-blue-web-90 font-semibold | mb-7 md:mb-9">
            Meet Your Host
          </h2>
          {speakersList.map(speaker => {
            return (
              <div key={speaker.id} className="flex gap-5 md:gap-8 | mb-8">
                <Image
                  src={speaker.image.data.attributes.url}
                  alt={speaker.image.data.attributes.alternativeText ?? ''}
                  width={speaker.image.data.attributes.width}
                  height={speaker.image.data.attributes.height}
                  className="w-36 h-36 bg-yellow-40 rounded-full border border-blue-40"
                />
                <div>
                  <div className="mb-2">
                    <Link
                      href={speaker.linkedinURL}
                      target="_blank"
                      className="w-5 h-5 | mb-2"
                    >
                      <LinkedIn />
                    </Link>
                  </div>
                  {speaker.tag ? (
                    <div className="text-small font-semibold | inline-block border border-black rounded-md | py-1 px-2 mb-2">
                      {speaker.tag}
                    </div>
                  ) : null}
                  <div className="font-heading text-lg md:text-2xl font-semibold | mb-2">
                    {speaker.name}
                  </div>
                  <div className="text-small md:text-sm | mb-2">
                    {speaker.description}
                  </div>
                  {speaker.companyImage.data ? (
                    <div className="flex items-center gap-2">
                      <Image
                        src={speaker.companyImage.data.attributes.url}
                        alt={
                          speaker.companyImage.data.attributes
                            .alternativeText ?? ''
                        }
                        width={speaker.companyImage.data.attributes.width}
                        height={speaker.companyImage.data.attributes.height}
                        className="w-16 md:w-22"
                      />
                    </div>
                  ) : null}
                </div>
              </div>
            )
          })}
        </div>
        <div className="md:col-start-7 md:col-end-13">
          <div className="mb-6 md:mb-14">
            <h2 className="font-heading text-2xl md:text-3xl text-blue-web-90 font-semibold | mb-7 md:mb-9">
              About Session
            </h2>
            <div
              className="text-sm md:text-lg text-gray-60"
              dangerouslySetInnerHTML={{
                __html: aboutSession
              }}
            />
          </div>
          <div>
            <h2 className="font-heading text-2xl md:text-3xl text-blue-web-90 font-semibold | mb-7 md:mb-9">
              Key Takeaways
            </h2>
            <div
              className={clsx(
                styles.description,
                'text-sm md:text-lg text-gray-60'
              )}
              dangerouslySetInnerHTML={{
                __html: takeaways
              }}
            />
          </div>
        </div>
      </div>
    </section>
  )
}

export default EventDetails
